import Link from 'next/link';
import { SaneImage } from '@components/sanity/sane-image';
import { urlForImage } from '@lib/sanity';
import { DocsTutorialContent } from '@types';
import clsx from 'clsx';
import Image from 'next/image';

type Props = {
  post: DocsTutorialContent;
};

export function PostCard({ post }: Props) {
  return (
    <Link
      href={post.slug}
      className={clsx(
        'group relative block space-y-4 overflow-hidden rounded-2xl bg-white shadow-lg ring-1 ring-gray-950/[0.05] transition dark:bg-[#1F2024] dark:ring-0',
        'after:pointer-events-none after:z-50 after:rounded-2xl after:dark:absolute after:dark:inset-0 after:dark:shadow-[inset_0px_1px_0px_rgba(255,255,255,0.06),inset_0px_-1px_0px_rgba(255,255,255,0.02),inset_1px_0px_0px_rgba(255,255,255,0.03),inset_-1px_0px_0px_rgba(255,255,255,0.03)]'
      )}
    >
      <div className="flex h-full flex-col">
        <div className="relative hidden h-40 xl:block">
          {/* @ts-ignore */}
          <SaneImage
            layout="fill"
            alt={post.title}
            src={post.coverImage}
            height={undefined}
            width={undefined}
            wrapClassName={undefined}
          />
        </div>

        <div className="flex flex-1 flex-col justify-between space-y-4 p-6">
          <div className="space-y-2">
            <span className="text-xs font-bold uppercase tracking-widest text-slate-500">
              {post.category}
            </span>
            <h3 className="text-lg text-black dark:text-white">{post.title}</h3>
            <p className="text-sm/5 tracking-tight text-black/60 dark:text-white/60">
              {post.excerpt}
            </p>
          </div>
          <div className="flex items-center gap-4">
            <div className="aspect-square relative h-12 overflow-hidden rounded-full">
              <Image
                src={urlForImage(post.author.picture.asset).url() as string}
                alt={post.author.name}
                fill
              />
            </div>
            <span className="text-sm font-semibold text-black dark:text-white">
              {post.author.name}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
